import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LandingNav from "../components/landing/LandingNav";
import HeroSection from "../components/landing/HeroSection";
import EcosystemSection from "../components/landing/EcosystemSection";
import PricingSection from "../components/landing/PricingSection";
import VisionSection from "../components/landing/VisionSection";
import FaqSection from "../components/landing/FaqSection";
import LandingFooter from "../components/landing/LandingFooter";
import "../styles/saas.css";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    const target = location.pathname === "/pricing" ? "#pricing" : location.hash;
    if (!target) return;
    const el = document.querySelector(target);
    if (el) {
      window.requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="saas-landing-page">
      <LandingNav />
      <HeroSection />
      <EcosystemSection />
      <PricingSection />
      <VisionSection />
      <FaqSection />
      <LandingFooter />
    </div>
  );
}
